module.exports = __webpack_public_path__ + "assets/images/pages/ministerioconsumo/grid-3.png?a52afbb9";